module.exports = __webpack_public_path__ + "img/gongzhong.893964b8.jpg";